"use client"

// [VV5-TEARDOWN] lp-free-shipping A/B test (DEV-9829, store since DEV-10696):
// delete this file at teardown. See the checklist in
// @local/tracking/src/experiments/freeShipping.
//
// Client leaf for one USP tile heading. <ServicePromise> is a server component
// on the statically prerendered store home, so the arm cannot be read there.
// This leaf renders the CMS heading during SSR and hydration (server snapshot
// `false`), then swaps to `testTitle` once the cookie says `test`. Same
// useSyncExternalStore pattern as Vv5Topbar: no effect, no setState, no
// hydration mismatch.
import Cookies from "js-cookie"
import { useSyncExternalStore } from "react"
import {
  VV5_COOKIE,
  shouldChargeShipping,
} from "@local/tracking/src/experiments/freeShipping"

interface Vv5ServicePromiseHeadingProps {
  /** CMS heading (control arm), HTML allowed. */
  title: string
  /** Replacement heading for the test arm (`chrome.fastShipping`). */
  testTitle: string
}

const noopSubscribe = () => () => {}

export const Vv5ServicePromiseHeading = ({
  title,
  testTitle,
}: Vv5ServicePromiseHeadingProps) => {
  const chargeShipping = useSyncExternalStore(
    noopSubscribe,
    () => shouldChargeShipping(Cookies.get(VV5_COOKIE)),
    () => false
  )

  // Mirrors the <p> in ServicePromiseIcon so both arms look identical.
  return (
    <p
      className="text-xl text-white uppercase"
      dangerouslySetInnerHTML={{ __html: chargeShipping ? testTitle : title }}
    />
  )
}
